import { gql, useQuery } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { GetSampleDescriptionInput, Query } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

const GET_SAMPLE_DESCRIPTION_QUERY = gql`
  query getSampleDescription($tenantID: ID!) {
    getSampleDescription(request: { tenantID: $tenantID }) {
      sampleDescription {
        name
        description
      }
    }
  }
`;

export const useFetchSampleDescriptions = () => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const { data, loading: isLoading } = useQuery<
    Query,
    GetSampleDescriptionInput
  >(GET_SAMPLE_DESCRIPTION_QUERY, {
    variables: { tenantID },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to fetch sample descriptions.',
        props: {},
      });
    },
  });

  return {
    sampleDescriptions: data?.getSampleDescription?.sampleDescription ?? [],
    isLoading: !data ? isLoading : false,
  };
};
